import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import { getUrl } from '../../tools/mappers';
import { LargeCard } from './LargeCards';

const AdditionalResourceCard = ({ post }) => {
  let description = get(post, 'description.description');
  if (!description) {
    description = get(post, 'articleDescription.childMarkdownRemark.html', '');
  }
  if (description) {
    description = description.replace(/<p>/gi, '').replace(/<\/p>/gi, '');
  }
  let viewLabel = get(post, 'contentType.viewLabel');
  if (!viewLabel) {
    viewLabel = 'Read the post.';
  }
  let url = getUrl(post);

  return (
    <LargeCard
      imageFragment={post.pageMeta?.ogImage || post.heroImage}
      type={post.contentType?.title}
      title={post.title}
      description={description}
      url={url}
      ctaLabel={viewLabel}
    />
  );
};

AdditionalResourceCard.propTypes = {
  post: PropTypes.object.isRequired,
};

export default AdditionalResourceCard;
